import productsApi from '~/pages/api/services/products-api';

async function getListGameFeatured(locale: any, type: any) {
  let dataListGameFeatured: any[] = [];
  await productsApi
    .getListProductsFeature({type: type, sort: 'FEATURED', filter: {}, limit: 6}, locale)
    .then((res: any) => {
      if (res?.status !== 200) {
        throw res;
      }
      const {data} = res?.data;
      if (data?.length) {
        dataListGameFeatured = data.splice(0, 6);
      }
    })
    .catch(() => {});
  return dataListGameFeatured;
}

export default getListGameFeatured;
